/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import { EntityId } from '../../types/api/EntityId';
import { CreateServiceActions, CreateServiceActionTypes } from './types';

export const openCreateServiceOverlay = ({
  organizationId,
  projectId,
  clusterId,
}: {
  organizationId?: EntityId;
  projectId?: EntityId;
  clusterId?: EntityId;
}): CreateServiceActionTypes => ({
  type: CreateServiceActions.OPEN_CREATE_SERVICE_OVERLAY,
  payload: {
    organizationId,
    projectId,
    clusterId,
  },
});

export const closeCreateServiceOverlay = (): CreateServiceActionTypes => ({
  type: CreateServiceActions.CLOSE_CREATE_SERVICE_OVERLAY,
});
